import type { CSSProperties } from "react";

const paths = {
  refresh: "M20 8a8 8 0 0 0-14-3L3 8 M3 3v5h5 M4 16a8 8 0 0 0 14 3l3-3 M21 21v-5h-5",
  filter: "M3 5h18l-7 8v6l-4 2v-8L3 5Z",
  search: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0 m-2 5 6 6",
  archive: "M3 4h18v4H3z M5 8v13h14V8 M9 12h6",
  restore: "M4 10a8 8 0 1 1 1 9 M4 4v6h6",
  feed: "M4 4h16v16H4z M8 8h8 M8 12h8 M8 16h5",
  inbox: "M4 4h16v16H4z M4 13h5l2 3h2l2-3h5",
  sent: "m3 11 18-8-8 18-2-8-8-2Z M11 13 21 3",
  watching: "M12 8v4l3 2 M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  write: "m16 3 5 5-12 12H4v-5L16 3Z M13 6l5 5",
  correspondence: "M3 6h18v12H3z M3 7l9 6 9-6",
  account: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M4 21v-2a8 8 0 0 1 16 0v2",
  admin: "m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z M9 12l2 2 4-4",
  chevron: "m9 5 7 7-7 7",
  down: "m6 9 6 6 6-6",
  people: "M15 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0 M5 21v-3a7 7 0 0 1 14 0v3 M20 4a3 3 0 0 1 0 6 M23 19v-2a5 5 0 0 0-3-4",
  folder: "M3 7V4h6l2 3h10v13H3V7Z",
  lock: "M7 10V7a5 5 0 0 1 10 0v3 M5 10h14v11H5z M12 14v3",
  unlocked: "M7 10V7a5 5 0 0 1 9-3 M5 10h14v11H5z M12 14v3",
  download: "M12 3v12 m-4-4 4 4 4-4 M4 16v5h16v-5",
  paperclip: "m8 12 7-7a3 3 0 0 1 4 4L9 19a5 5 0 0 1-7-7L13 1 M6 14l9-9",
  close: "m6 6 12 12 M6 18 18 6",
  check: "m5 12 4 4L19 6",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  // Roles (PLAN.md 4.22): a crown, a custodian helmet (British police), a robot.
  crown: "M3 8l4.5 4L12 5l4.5 7L21 8l-2 10H5L3 8Z M5 21h14",
  helmet: "M8 17V9a4 6 0 0 1 8 0v8 M12 3V1.8 M4.5 16.5c2.5 2.5 12.5 2.5 15 0 M12 8l1.1 2.1 2.3.3-1.7 1.6.4 2.3-2.1-1.1-2.1 1.1.4-2.3-1.7-1.6 2.3-.3Z",
  robot: "M5 8h14v11H5z M12 8V5 M12 3.5v.01 M9 12.5v.01 M15 12.5v.01 M9 16h6 M2 12v3 M22 12v3",
} as const;

export function Icon({ name, size = 20 }: { name: keyof typeof paths; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 } as CSSProperties}><path d={paths[name]} /></svg>;
}
